module.exports = __webpack_public_path__ + "static/img/group.b30f329.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group.png
// module id = wiDa
// module chunks = 64